import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ProductCollectionField, ProductCollectionFieldOption } from 'src/app/interfaces/product-collections';
import { ProductCollectionService } from 'src/app/services/product-collection.service';

@Component({
  selector: 'app-lookup-products-collection',
  templateUrl: './product-collection.component.html',
  styleUrls: ['./product-collection.component.scss']
})
export class LookupProductsCollectionComponent implements OnInit, OnDestroy {
  selectAllAdditionalFields: boolean = false;
  selectedAdditionalFields: any[] = [];
  canGenerateReport: boolean = false;

  searchCatalog: boolean = false;

  additionalFields: ProductCollectionFieldOption[] = [
    {
      title: 'ASIN',
      name: 'ASIN',
    },
    {
      title: 'Color',
      name: 'COLOR',
    },
    {
      title: 'Brand',
      name: 'BRAND',
    },
    {
      title: 'Manufacturer',
      name: 'MANUFACTURER',
    },
    {
      title: 'Description',
      name: 'DESCRIPTION',
    },
    {
      title: 'AID',
      name: 'AID',
    },
    {
      title: 'Parent AID',
      name: 'PARENT_AID',
    },
    {
      title: 'Image',
      name: 'IMAGES',
    },
    {
      title: 'MSRP',
      name: 'MSRP',
    },
    {
      title: 'Variation',
      name: 'VARIATION',
    },
    {
      title: 'Title',
      name: 'TITLE',
    },
    {
      title: 'Signals',
      name: 'SIGNALS',
    },
    {
      title: 'Categories ID',
      name: 'CATEGORIES_ID',
    },
    {
      title: 'Seller ID',
      name: 'SELLER_ID',
    },
    {
      title: 'Status',
      name: 'STATUS',
    },
    {
      title: 'Number of Offers',
      name: 'NUMBER_OF_OFFERS',
    },
    {
      title: 'Parent ASIN',
      name: 'PARENT_ASIN',
    },
  ];

  fields: ProductCollectionField[] = [
    {
      title: 'Categories',
      name: 'categories',
      type: 'text',
      searchCatalog: true
    },
    {
      title: 'Brand Name',
      name: 'brandName',
      type: 'brand-search'
    },
    {
      title: 'Manufacturer Name',
      name: 'manufacturerName',
      type: 'text',
    },
    {
      title: 'Color',
      name: 'color',
      type: 'text',
    },
    {
      title: 'Min. Price',
      name: 'minPrice',
      type: 'text',
    },
    {
      title: 'Max. Price',
      name: 'maxPrice',
      type: 'text',
    },
    {
      title: 'Min. Sales Rank',
      name: 'minSalesRank',
      type: 'text',
    },
    {
      title: 'Max. Sales Rank',
      name: 'maxSalesRank',
      type: 'text',
    },
    {
      title: 'Product Status',
      name: 'productStatus',
      type: 'checkbox',
      options: [
        {
          title: 'Active',
          name: 'ACTIVE',
        },
        {
          title: 'Inactive',
          name: 'INACTIVE',
        },
        {
          title: 'Active with Offers',
          name: 'ACTIVE_WITH_OFFERS',
        },
        {
          title: 'Active without Offers',
          name: 'ACTIVE_WITHOUT_OFFERS',
        },
      ]
    },
    {
      title: 'Exclude Categories',
      name: 'excludeCategories',
      type: 'text',
    },
    {
      title: 'Product Variant',
      name: 'productVariant',
      type: 'radio',
      options: [
        {
          title: 'Parent',
          name: 'PARENT',
        },
        {
          title: 'Variant',
          name: 'VARIANT',
        },
      ]
    },
    {
      title: 'Seller IDS',
      name: 'sellerIds',
      type: 'text',
    },
    {
      title: 'Max. Items',
      name: 'maxItems',
      type: 'text',
      searchCatalog: true
    },
  ];

  productCollectionServiceChangedSubscription!: Subscription;

  constructor(
    private productCollectionService: ProductCollectionService
  ) { }

  ngOnInit(): void {
    $(document).off('click', '.value-div:not(.disabled)');
    $(document).on('click', '.value-div:not(.disabled)', function () {
      const field = $(this).parents('.collapsible-field');
      field.toggleClass('opened');
      field.find('.collapsible-content').slideToggle();
    });

    this.productCollectionServiceChangedSubscription = this.productCollectionService.watchChanges.subscribe(() => {
      const fieldIndex = this.fields.findIndex(field => field.name === 'categories');
      this.fields[fieldIndex].value = this.productCollectionService.categoryIds;
    });
  }

  ngOnDestroy() {
    this.productCollectionServiceChangedSubscription.unsubscribe();
  }

  onChangeSearchCatalog() {
    if (this.searchCatalog) {
      this.fields.map(field => {
        if (!field.searchCatalog) {
          field.checked = false;
          field.value = '';
          field.valueShow = '';
        }
      });
    }
  }

  onChangeValue(field: ProductCollectionField, value: string = '') {
    if (field.name === 'categories') {
      this.productCollectionService.categoryIds = field.value || '';
      this.productCollectionService.changesMade();
    }

    if (field.type === 'checkbox') {
      field.value = field.options?.filter(option => option.checked).map(option => option.name).join(',');
      field.valueShow = field.options?.filter(option => option.checked).map(option => option.title).join(', ');
    } else if (field.type === 'radio') {
      field.value = value;
      field.valueShow = field.options?.find(option => option.name === value)?.title;
    }
    this.canGenerateReport = this.fields.filter(field => field.checked && field.value).length > 0;
  }

  onChangeFieldCheck(field: ProductCollectionField) {
    if (field.type === 'text' && field.checked) {
      setTimeout(() => {
        const checkboxField = document.getElementById('field-text-field-' + field.name) as HTMLInputElement;
        checkboxField.focus();
      });
    }

    this.fields.map((field) => {
      if (!field.checked) {
        field.value = '';
        field.valueShow = '';
        if (field.type) {
          const fieldElem = $('.collapsible-field[data-field="' + field.name + '"]');
          fieldElem.removeClass('opened');
          fieldElem.find('.collapsible-content').slideUp();
          field.options?.map(option => option.checked = false);
        }
      }
    });
  }

  onChangeAdditionalField = () => {
    this.selectedAdditionalFields = this.additionalFields.filter(item => item.checked);
  };

  selectAllAdditionalFieldsCheckboxes() {
    this.additionalFields.map(item => item.checked = this.selectAllAdditionalFields);
    this.onChangeAdditionalField();
  }

  getAdditionalFieldsValueShow = (): string => {
    return this.selectedAdditionalFields.map(item => item.title).join(', ');
  };

  getReportRequestParams(): Record<string, string> {
    const reportFieldsData: Record<string, string> = {};
    this.fields.filter(field => field.checked && field.value).map(field => {
      if (field.value) {
        reportFieldsData[field.name] = field.value || '';
      }
    });
    reportFieldsData['searchCatalog'] = this.searchCatalog.toString();
    if (this.selectedAdditionalFields.length > 0) {
      reportFieldsData['additionalFields'] = this.selectedAdditionalFields.map(item => item.name).join(',');
    }
    return reportFieldsData;
  }
}
